import { Directive, HostListener } from "@angular/core";
const navigationKeys = [
  "Backspace",
  "Delete",
  "Tab",
  "Escape",
  "Enter",
  "Home",
  "End",
  "ArrowLeft",
  "ArrowRight",
  "Clear",
  "Copy",
  "Paste",
];

const isNavKey = (e) =>
  navigationKeys.indexOf(e.key) > -1 ||
  (e.key === "a" && e.ctrlKey) || // Allow: Ctrl+A
  (e.key === "c" && e.ctrlKey) || // Allow: Ctrl+C
  (e.key === "v" && e.ctrlKey) || // Allow: Ctrl+V
  (e.key === "x" && e.ctrlKey) || // Allow: Ctrl+X
  (e.key === "a" && e.metaKey) || // Cmd+A (Mac)
  (e.key === "c" && e.metaKey) || // Cmd+C (Mac)
  (e.key === "v" && e.metaKey) || // Cmd+V (Mac)
  (e.key === "x" && e.metaKey); // Cmd+X (Mac)

@Directive({
  selector: "[numberOnly]",
})
export class NumberOnlyDirective {
  @HostListener("keydown", ["$event"])
  onKeyDown(e: KeyboardEvent) {
    if (isNavKey(e)) {
      return;
    }
    if (e.key === " " || isNaN(Number(e.key))) {
      e.preventDefault();
    }
  }
}
